import { render, staticRenderFns } from "./navPhone.vue?vue&type=template&id=62d10814&"
import script from "./navPhone.vue?vue&type=script&lang=js&"
export * from "./navPhone.vue?vue&type=script&lang=js&"
import style0 from "./navPhone.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./navPhone.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports